import type {
  IBillingHistory,
  IInsightCardData,
  IJobCreationPoint,
  ILicenseDistributionItem,
  IOrganizationRole,
  IOrgUser,
  ISecurityLog,
  IUsageChartPoint,
  OrganizationDetailTab,
  OverviewTimeframe,
} from '../interfaces';

export const ORGANIZATION_DETAIL_TABS: OrganizationDetailTab[] = [
  'Overview',
  'Billing & Subscription',
  'Billing History',
  'Users',
  'Permissions',
  'Security Log',
];

export const DEFAULT_DETAIL_TAB: OrganizationDetailTab = 'Overview';

export const OVERVIEW_TIMEFRAMES: OverviewTimeframe[] = ['Daily', 'Monthly', 'Yearly'];

export const DEFAULT_OVERVIEW_TIMEFRAME: OverviewTimeframe = 'Monthly';

export const AVATAR_COLOR_CLASSES: string[] = [
  'bg-blue-500', 'bg-emerald-500', 'bg-violet-500',
  'bg-amber-500', 'bg-rose-500', 'bg-cyan-500', 'bg-indigo-500',
];

export const MOCK_BILLING_HISTORY: IBillingHistory[] = [
  {
    id: 'INV-001',
    date: '2024-03-01',
    amount: '$12,500.00',
    status: 'Paid',
    method: 'Visa **** 4242',
  },
  {
    id: 'INV-002',
    date: '2023-03-01',
    amount: '$12,500.00',
    status: 'Paid',
    method: 'Visa **** 4242',
  },
  {
    id: 'INV-003',
    date: '2022-03-01',
    amount: '$10,000.00',
    status: 'Paid',
    method: 'Bank Transfer',
  },
];

export const MOCK_ORG_USERS: IOrgUser[] = [
  {
    id: 1,
    name: 'Jane Doe',
    email: 'jane.doe@acmeglobal.com',
    role: 'Owner',
    status: 'Active',
    joined: 'June 2021',
  },
  {
    id: 2,
    name: 'John Smith',
    email: 'john.smith@acmeglobal.com',
    role: 'Admin',
    status: 'Active',
    joined: 'July 2021',
  },
  {
    id: 3,
    name: 'Sarah Jenkins',
    email: 'sarah.j@acmeglobal.com',
    role: 'Admin',
    status: 'Active',
    joined: 'August 2021',
  },
  {
    id: 4,
    name: 'Michael Chen',
    email: 'm.chen@acmeglobal.com',
    role: 'Member',
    status: 'Inactive',
    joined: 'January 2022',
  },
];

export const MOCK_SECURITY_LOGS: ISecurityLog[] = [
  {
    id: 1,
    action: 'User Login',
    user: 'Jane Doe',
    ip: '192.168.1.1',
    timestamp: '2024-03-02 10:15:30',
  },
  {
    id: 2,
    action: 'License Updated',
    user: 'John Smith',
    ip: '192.168.1.5',
    timestamp: '2024-03-02 09:45:00',
  },
  {
    id: 3,
    action: 'New User Invited',
    user: 'Jane Doe',
    ip: '192.168.1.1',
    timestamp: '2024-03-01 16:20:15',
  },
  {
    id: 4,
    action: 'Security Settings Changed',
    user: 'System',
    ip: '-',
    timestamp: '2024-03-01 12:00:00',
  },
];

export const MOCK_ORGANIZATION_ROLES: IOrganizationRole[] = [
  {
    name: 'Owner',
    description: 'Full access to all settings, billing, and user management.',
    users: 1,
    permissions: ['All Permissions'],
  },
  {
    name: 'Admin',
    description: 'Can manage members and most settings, but cannot delete the organization.',
    users: 2,
    permissions: ['Manage Users', 'Manage Billing', 'View Reports', 'Edit Profile'],
  },
  {
    name: 'Member',
    description: 'Standard access to organization data and reports.',
    users: 18,
    permissions: ['View Reports', 'View Members'],
  },
];

export const DAILY_USAGE_DATA: IUsageChartPoint[] = [
  { name: 'Mon', hierTalent: 400, candiBank: 240, assessments: 180 },
  { name: 'Tue', hierTalent: 300, candiBank: 139, assessments: 220 },
  { name: 'Wed', hierTalent: 200, candiBank: 980, assessments: 290 },
  { name: 'Thu', hierTalent: 278, candiBank: 390, assessments: 200 },
  { name: 'Fri', hierTalent: 189, candiBank: 480, assessments: 218 },
  { name: 'Sat', hierTalent: 239, candiBank: 380, assessments: 250 },
  { name: 'Sun', hierTalent: 349, candiBank: 430, assessments: 210 },
];

export const MONTHLY_USAGE_DATA: IUsageChartPoint[] = [
  { name: 'Jan', hierTalent: 4000, candiBank: 2400, assessments: 2400 },
  { name: 'Feb', hierTalent: 3000, candiBank: 1398, assessments: 2210 },
  { name: 'Mar', hierTalent: 2000, candiBank: 9800, assessments: 2290 },
  { name: 'Apr', hierTalent: 2780, candiBank: 3908, assessments: 2000 },
  { name: 'May', hierTalent: 1890, candiBank: 4800, assessments: 2181 },
  { name: 'Jun', hierTalent: 2390, candiBank: 3800, assessments: 2500 },
];

export const YEARLY_USAGE_DATA: IUsageChartPoint[] = [
  { name: '2021', hierTalent: 35000, candiBank: 24000, assessments: 21000 },
  { name: '2022', hierTalent: 45000, candiBank: 32000, assessments: 28000 },
  { name: '2023', hierTalent: 62000, candiBank: 48000, assessments: 39000 },
  { name: '2024', hierTalent: 78000, candiBank: 54000, assessments: 45000 },
];

export const JOB_CREATION_DATA: IJobCreationPoint[] = [
  { month: 'Jan', count: 12 },
  { month: 'Feb', count: 18 },
  { month: 'Mar', count: 15 },
  { month: 'Apr', count: 22 },
  { month: 'May', count: 30 },
  { month: 'Jun', count: 25 },
];

export const TOTAL_JOBS_CREATED = 115;

export const INSIGHT_CARDS: IInsightCardData[] = [
  {
    title: 'Applicants per JO',
    metrics: [
      { label: 'Minimum', value: 12 },
      { label: 'Average', value: 48 },
      { label: 'Maximum', value: 154 },
    ],
    color: 'blue',
  },
  {
    title: 'Auto-Assessments (Assigned)',
    metrics: [
      { label: 'Minimum', value: 8 },
      { label: 'Average', value: 32 },
      { label: 'Maximum', value: 98 },
    ],
    color: 'amber',
  },
  {
    title: 'Auto-Assessments (Completed)',
    metrics: [
      { label: 'Minimum', value: 5 },
      { label: 'Average', value: 24 },
      { label: 'Maximum', value: 76 },
    ],
    color: 'emerald',
  },
  {
    title: 'SmartInterviews (Invited)',
    metrics: [
      { label: 'Minimum', value: 2 },
      { label: 'Average', value: 12 },
      { label: 'Maximum', value: 34 },
    ],
    color: 'rose',
  },
  {
    title: 'SmartInterviews (Completed)',
    metrics: [
      { label: 'Minimum', value: 1 },
      { label: 'Average', value: 9 },
      { label: 'Maximum', value: 28 },
    ],
    color: 'indigo',
  },
];

/** Static Tailwind classes per insight color (dynamic `bg-${color}-*` names do not compile). */
export const INSIGHT_COLOR_CLASSES: Record<string, { glow: string; bar: string }> = {
  blue: { glow: 'bg-blue-500/5', bar: 'bg-blue-500/50' },
  amber: { glow: 'bg-amber-500/5', bar: 'bg-amber-500/50' },
  emerald: { glow: 'bg-emerald-500/5', bar: 'bg-emerald-500/50' },
  rose: { glow: 'bg-rose-500/5', bar: 'bg-rose-500/50' },
  indigo: { glow: 'bg-indigo-500/5', bar: 'bg-indigo-500/50' },
};

export interface IMetricTile {
  label: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  iconClassName: string;
  iconPath: string;
}

export const OVERVIEW_METRIC_TILES: IMetricTile[] = [
  {
    label: 'Allocated Licenses',
    value: '2,500',
    change: '+12%',
    trend: 'up',
    iconClassName: 'bg-emerald-50 text-emerald-600',
    iconPath: 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z',
  },
  {
    label: 'Monthly Active Users',
    value: '2,184',
    change: '+5.2%',
    trend: 'up',
    iconClassName: 'bg-blue-50 text-blue-600',
    iconPath: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
  },
  {
    label: 'API Consumption',
    value: '84.2%',
    change: '-2.1%',
    trend: 'down',
    iconClassName: 'bg-amber-50 text-amber-600',
    iconPath: 'M13 10V3L4 14h7v7l9-11h-7z',
  },
];

export const LICENSE_DISTRIBUTION: ILicenseDistributionItem[] = [
  { label: 'Productivity Suite (Enterprise)', used: '1,850', total: '2,000', color: 'emerald' },
  { label: 'Storage Add-on (5TB)', used: '3.2TB', total: '5.0TB', color: 'blue' },
  { label: 'Premium Support', status: 'Active', color: 'amber' },
];

export const LICENSE_DISTRIBUTION_BAR_CLASSES: Record<string, string> = {
  emerald: 'bg-emerald-500',
  blue: 'bg-blue-500',
  amber: 'bg-amber-500',
};
